export default "__VITE_ASSET__DIl8wIoO__"